module.exports = __webpack_public_path__ + "img/succesmark.e4debf49.png";